export default {
  isDarkTheme: localStorage.getItem("user-theme") === "dark-theme",
  user: null,
  hasSub: null,
  subDaysLeft: 0,
  guestPermissions: [] // A-10: права статуса guest для неавторизованного
};
